import OpenInNewIcon from 'mdi-react/OpenInNewIcon'
import { twJoin } from 'tailwind-merge'

import { Translation } from '../i18n/Translation'
import { LocalDate } from '../LocalDate'

import { goToForm } from './helpers'
import type { MyAssetsInjuryReport } from './types'

export type InjuryReportListProps = {
  injuryReports: MyAssetsInjuryReport[]
}

export const InjuryReportList = ({ injuryReports }: InjuryReportListProps) => (
  <div className="border-t border-gray-200 bg-gray-50 px-4 py-3">
    <h4 className="mb-2 text-sm font-medium text-gray-700">
      <Translation id="Injury Reports:" />
    </h4>
    <ul className="space-y-2 pl-0 sm:pl-6 md:pl-10">
      {injuryReports?.map(report => (
        <li key={report.injuryReportId} className="flex items-center justify-between">
          <span className="text-sm text-gray-600">
            <LocalDate date={report.injuryReportCreated} /> -{' '}
            <Translation id={`INJURY_REPORT_STATUS/${report.injuryReportStatus}`} />
          </span>
          <OpenInNewIcon
            onClick={() => goToForm(report.injuryReportCode)}
            className={twJoin(
              'h-6 w-6 cursor-pointer text-gray-500 transition-colors duration-200',
              'hover:text-gray-700 active:scale-95'
            )}
          />
        </li>
      ))}
    </ul>
  </div>
)
